import { render } from "./ContentblockPhotoSlider.vue?vue&type=template&id=7faff25d&ts=true"
import script from "./ContentblockPhotoSlider.ts?vue&type=script&lang=ts"
export * from "./ContentblockPhotoSlider.ts?vue&type=script&lang=ts"

import "./ContentblockPhotoSlider.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__